import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';

interface Props {
  children: React.ReactNode;
  title: string;
}

const LegalPageLayout: React.FC<Props> = ({ children, title }) => {
  return (
    <div className="bg-slate-900 min-h-screen text-slate-300 font-sans antialiased">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-24 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white mb-8">{title}</h1>
        <div className="prose prose-invert prose-slate max-w-none">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LegalPageLayout;